import { type ReactElement } from 'react'

import { Section } from '@orus.eu/pharaoh-next/components/ui/section'
import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'

import { CertificateGeneratorSkeleton } from '../shared/components/certificate-generator-skeleton.tsx'
import { FieldSkeleton } from '../shared/components/field-skeleton.tsx'
import { FormRow } from '../shared/components/form-row.tsx'

/**
 * Pending state for `InsuranceCertificateGeneratorRealEstateAgentsPage`: the CPI section, then the
 * activities picker. The representatives block is left out on purpose — it only renders for a
 * `morale` persona, which is unknown while the contract is loading.
 */
export function InsuranceCertificateGeneratorRealEstateAgentsPageSkeleton(): ReactElement {
  return (
    <CertificateGeneratorSkeleton>
      <Section.Root>
        <FormRow>
          <FieldSkeleton />
        </FormRow>
        <FormRow>
          <FieldSkeleton />
          <FieldSkeleton />
          <FieldSkeleton />
        </FormRow>
      </Section.Root>

      {/* The activities picker: its legend, then the three-row outlined group. */}
      <div className="flex flex-col gap-30">
        <Skeleton variant="text" width={260} height={20} />
        <Skeleton variant="block" height={168} />
      </div>
    </CertificateGeneratorSkeleton>
  )
}
